// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZervantToggle {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  display: inline-block;
  font-size: 11px;
  min-height: 24px;
  color: #FFF;
  cursor: pointer;
}
.ZervantToggle__container {
  border-radius: 15px;
  line-height: 24px;
  padding-left: 10px;
  padding-right: 10px;
  position: relative;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
  will-change: background-color;
}
.ZervantToggle__container span {
  -webkit-transition: padding 0.2s ease-in-out;
  transition: padding 0.2s ease-in-out;
}
.ZervantToggle__container--on {
  color: #002E33;
  background-color: #01FF94;
}
.ZervantToggle__container--on i {
  right: 5px;
}
.ZervantToggle__container--on span {
  padding-right: 15px;
}
.ZervantToggle__container--off {
  background-color: #697588;
}
.ZervantToggle__container--off i {
  right: calc(100% - 20px);
}
.ZervantToggle__container--off span {
  padding-left: 15px;
  text-align: right;
}
.ZervantToggle__container i {
  -webkit-transition: right 0.2s;
  transition: right 0.2s;
  will-change: right;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: absolute;
  background-color: #FFF;
  top: calc(50% - 8px);
  -webkit-box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.16);
          box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.16);
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/Toggle/Toggle.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;KAAA,sBAAA;MAAA,qBAAA;UAAA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,WCCM;EDCN,eAAA;AAFF;AAIE;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EAAA,iCAAA;EACA,6BAAA;AAFJ;AAGI;EACE,4CAAA;EAAA,oCAAA;AADN;AAGI;EACE,cCrBS;EDsBT,yBCvBU;ADsBhB;AAEM;EACE,UAAA;AAAR;AAEM;EACE,mBAAA;AAAR;AAII;EACE,yBCmBG;ADrBT;AAGM;EACE,wBAAA;AADR;AAGM;EACE,kBAAA;EACA,iBAAA;AADR;AAKI;EACE,8BAAA;EAAA,sBAAA;EACA,kBAAA;EACA,WAvCO;EAwCP,YAxCO;EAyCP,kBAAA;EACA,kBAAA;EACA,sBC3CE;ED4CF,oBAAA;EACA,qDAAA;UAAA,6CAAA;AAHN","sourcesContent":["@import '../../../Global/Colors.scss';\n\n.ZervantToggle {\n  user-select: none;\n  display: inline-block;\n  font-size: 11px;\n  min-height: 24px;\n  color: $White;\n  $knobSize: 16px;\n  cursor: pointer;\n\n  &__container {\n    border-radius: 15px;\n    line-height: 24px;\n    padding-left: 10px;\n    padding-right: 10px;\n    position: relative;\n    transition: background-color 0.2s;\n    will-change: background-color;\n    span {\n      transition: padding 0.2s ease-in-out;\n    }\n    &--on {\n      color: $DeepSeaGreen;\n      background-color: $ElectricGreen;\n      i {\n        right: 5px;\n      }\n      span {\n        padding-right: 15px;\n      }\n    }\n\n    &--off {\n      background-color: $Gray90;\n      i {\n        right: calc(100% - 20px);\n      }\n      span {\n        padding-left: 15px;\n        text-align: right;\n      }\n    }\n\n    i {\n      transition: right 0.2s;\n      will-change: right;\n      width: $knobSize;\n      height: $knobSize;\n      border-radius: 50%;\n      position: absolute;\n      background-color: $White;\n      top: calc(50% - 8px);\n      box-shadow: 1px 1px 3px 0 rgba($Black, 0.16);\n    ;\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
